import React from "react";
import { useFormContext } from "react-hook-form";
import { Switch } from "components";
import { OcclusionEnum, OralStateEnum } from "requests";
import { FormValues } from "../../duck";
import { ORAL_STATE_KEYS } from "./duck";

const AllNormalToggle: React.FC = () => {
  const { watch, reset } = useFormContext<FormValues>();
  const oralStateValues = watch([
    ...ORAL_STATE_KEYS,
    "fistula",
    "parulisSinusTract",
    "occlusion"
  ]);
  const isChecked = oralStateValues.every(
    value =>
      value === OralStateEnum.Normal ||
      value === OcclusionEnum.Normal ||
      value === false
  );

  return (
    <Switch
      label="All normal"
      isChecked={isChecked}
      onChange={checked => {
        reset({
          ...Object.fromEntries(
            ORAL_STATE_KEYS.map(key => [
              key,
              checked ? OralStateEnum.Normal : null
            ])
          ),
          fistula: checked ? false : null,
          parulisSinusTract: checked ? false : null,
          occlusion: checked ? OcclusionEnum.Normal : null
        });
      }}
    />
  );
};

export default AllNormalToggle;
